import { GD } from "../GD";

export interface ICardWithAccount extends ICard {
	account: IAccount;
}

export interface ICardsPagination {
	cards: ICard[];
	pagination: { perPage: number; page: number; totalPages: number };
	total: number;
}

export class CardService {
	constructor() {
		GD.REQ_CARDS.listener = async req => this.loadCards(req);
		GD.REQ_CARD.listener = async req => this.loadCardAndAccount(req.uid);
		GD.REQ_CARDS_BY_USER.listener = async req => this.loadCardsByUser(req);
	}

	async loadCardsByUser({
		userUID,
	}: {
		userUID: string;
	}): Promise<IAPIResponse<ICard[]>> {
		return GD.REQ_API.request({
			method: "card/get",
			data: { owner_uid: userUID },
		});
	}

	async loadCardAndAccount(
		cardUID: string,
	): Promise<IAPIResponse<ICardWithAccount>> {
		const card = await GD.REQ_API.request({
			method: "card/get",
			data: { uid: cardUID },
		});
		if (card.error) return card;

		const response = await GD.REQ_API.request({
			method: "card/account",
			data: { card_uid: cardUID },
		});
		if (!response.error) card.data.account = response.data;

		return card;
	}

	async loadCards(
		filter: ICardFilter,
	): Promise<IAPIResponse<ICardsPagination>> {
		return GD.REQ_API.request({
			method: "card/get",
			data: filter,
		});
	}
}
